<template>
  <div class="row">
    <div class="col-md-6">
      <b-card :header="displayName">
        {{displayName}}
        <span slot="footer">Go to <!-- <router-link class="font-weight-bold" :to="'/vehicles/' + detailedInfo.id"> -->profile<!-- </router-link> --> page</span>
      </b-card>
      <card-list-info header="Detail" :items="accountInfo"></card-list-info>
    </div>
    <div class="col-md-6">
      <b-card
        v-if="canIDeleteVehicle(detailedInfo)"
        header-bg-variant="danger" border-variant="danger" header="Remove this vehicle">
        <p>Removing vehicles has the following effects: </p>
        <ul class="pl-4">
          <li>Vehicle Group data will not be retrievable</li>
        </ul>
        <b-button v-b-modal.delete_vehicle variant="danger">Remove</b-button>
      </b-card>
    </div>
    <div>
      <b-modal
        id="delete_vehicle"
        title="Delete Vehicle"
        header-bg-variant="danger"
        ok-variant="danger"
        @ok="deleteVehicle()">
        <p class="my-4">Are you sure want to delete this vehicle group ?</p>
      </b-modal>
    </div>
  </div>
</template>
<script>
import dateMixin from '@/mixins/date';
import vehicleGroupMixin from '@/mixins/vehicle_group';
// import { find, isEmpty, isNull } from 'lodash';
// import get from 'lodash/get';

import CardListInfo from '@/components/CardListInfo';
import Multiselect from 'vue-multiselect';

export default {
  mixins: [dateMixin, vehicleGroupMixin],
  components: {
    CardListInfo,
    Multiselect,
  },
  data() {
    return {
      selectedCompany: null,
      selectedDriver: null,
      textButtonAssign: 'Assign',
    };
  },
  created() {
    this.$store.commit('vehicle_group/CLEAR_DATA');
  },
  computed: {
    companies() {
      return this.$store.getters['companies/companies'];
    },
    displayName() {
      if (!this.detailedInfo) return '';
      return this.detailedInfo.name;
    },
    detailedInfo() {
      return this.$store.getters['vehicle_group/get_detail_data'];
    },
    accountInfo() {
      /* eslint-disable */
      const info = this.detailedInfo;
      const infoList = [
        { key: 'name', label: 'Name', value: info.name },
        { key: 'description', label: 'Description', value: info.description },
        { key: 'company', label: 'Company', value: info.company.name },
        {
          key: 'created_at',
          label: 'Created at',
          value: this.formatDateDistance(info.created_at),
          title: this.formatDateTime(info.created_at),
        },
      ];

      return infoList;
    },
  },
  watch: {
    detailedInfo(data) {
      this.selectedCompany = data.company;
    },
  },
  methods: {
    deleteVehicle() {
      this.$store.dispatch('vehicle_group/DELETE_DATA').then((ok) => {
        if (ok) this.$router.push('/vehicle_group');
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/vehicle_group/detail/Preview.vue